export default __webpack_public_path__ + "static/wireframe1-8a464744404e8f18dffe62b611af1bac.png";